module.exports = __webpack_public_path__ + "img/category_26.27b82aba.png";